import { api } from "@/lib/api";
import { toast } from "sonner";

// FASE 14 — offline queue for checklist execution submissions.
// Failed POSTs (no network) are stored here and replayed when back online.
const QUEUE_KEY = "chefcheck.offline_queue";

export function getQueue() {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]");
  } catch {
    return [];
  }
}

function saveQueue(queue) {
  try {
    localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
  } catch (err) {
    console.warn("offline queue save failed", err);
  }
  window.dispatchEvent(new CustomEvent("chefcheck:queue-changed", { detail: { count: queue.length } }));
}

export function queueExecution({ executionId, payload, templateName }) {
  const queue = getQueue();
  queue.push({
    id: `${executionId}-${Date.now()}`,
    execution_id: executionId,
    payload,
    template_name: templateName || "Checklist",
    created_at: new Date().toISOString(),
  });
  saveQueue(queue);
}

export function isNetworkError(err) {
  return !err?.response || err?.code === "ERR_NETWORK";
}

let flushing = false;

export async function flushQueue() {
  if (flushing) return;
  const queue = getQueue();
  if (!queue.length || !navigator.onLine) return;
  flushing = true;
  let synced = 0;
  const remaining = [];
  try {
    for (const item of queue) {
      try {
        await api.post(`/checklists/executions/${item.execution_id}/complete`, item.payload);
        synced += 1;
      } catch (err) {
        const status = err?.response?.status;
        if (status && status >= 400 && status < 500 && status !== 401 && status !== 429) {
          // Stale item (already completed / invalid) — drop it.
          synced += 1;
        } else {
          remaining.push(item);
          if (isNetworkError(err)) {
            // Still offline — keep the rest for later.
            remaining.push(...queue.slice(queue.indexOf(item) + 1));
            break;
          }
        }
      }
    }
  } finally {
    saveQueue(remaining);
    flushing = false;
  }
  if (synced > 0) {
    toast.success(`${synced} checklist(s) sincronizado(s) com sucesso!`);
  }
}

let syncInitialized = false;

export function initOfflineSync() {
  if (syncInitialized) return;
  syncInitialized = true;
  window.addEventListener("online", () => {
    setTimeout(flushQueue, 1500);
  });
  if (navigator.onLine) {
    setTimeout(flushQueue, 3000);
  }
}
